import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
  fromDate: dayjs().startOf("month").format("YYYY-MM-DD"),
  toDate: dayjs().endOf("month").format("YYYY-MM-DD"),
  filterModel: null,
  quickFilterText: "",
};

const invoicesSlice = createSlice({
  name: "invoices",
  initialState,
  reducers: {
    setDates: (state, action) => {
      state.fromDate = action.payload.fromDate;
      state.toDate = action.payload.toDate;
    },
    setFilterModel: (state, action) => {
      state.filterModel = action.payload;
    },
    setQuickFilterText: (state, action) => {
      state.quickFilterText = action.payload;
    },
    resetInvoicesState: () => initialState,
  },
});

export const {
  setDates,
  setFilterModel,
  setQuickFilterText,
  resetInvoicesState,
} = invoicesSlice.actions;

export default invoicesSlice.reducer;